import React from "react";
import icon from '../assets/images/icona.png';
import {Col,Row,Container} from "reactstrap";
import Form from "../components/Form";
import ServicesCardMain from "../components/ServicesCardMain";
import Section from "./Section";
import Preloader from "../components/Preloader";
import NavBar from "../Layout/Navbar";
import Footer from "../Layout/Footer";
import FooterAlt from "../Layout/FooterAlt";
const Assistenza = () =>{
    const formLayout = {
        name:'noleggio',title:"Compila il form e ti risponderemo via mail",layout:[
            {fieldName:'nome',fieldDimensions:12,fieldLabel:'Nome e Cognome',fieldValidation:{required:true},fieldType:'text'},
            {fieldName:'email',fieldDimensions:6,fieldLabel:'Indirizzo email',fieldValidation:{required:true},fieldType:'email'},
            {fieldName:'telefono',fieldDimensions:6,fieldLabel:'Numero di telefono',fieldValidation:{required:true},fieldType:'number'},
            {fieldName:'modello',fieldDimensions:6,fieldLabel:'Tipo gruppop o modello',fieldValidation:{},fieldType:'text'},
            {fieldName:'potenza',fieldDimensions:6,fieldLabel:'Potenza(KW)',fieldValidation:{},fieldType:'text'},
            {fieldName:'tipoQuadro',fieldDimensions:9,fieldLabel:'Tipo Quadro',fieldValidation:{},fieldType:'text'},
            {fieldName:'tagliando',fieldLabel:'Tagliando',fieldDimensions:3,fieldValidation:{},fieldType:'checkbox'},
        ]
    }    
    return ( <React.Fragment>
        <NavBar />
            <Section leftSide="Assistenza"></Section>
            <ServicesCardMain imgsrc={icon} title="Assistenza" caption="Assistenza tecnica 24 ore su 24. Controlli in prima attivazione. Ricerca e Soluzione anomalie o guasti, messe a punto e controlli funzionali. Verifiche occasionali e periodiche. Pratiche U.T.F. e loro applicazioni, defiscalizzazione combustibile. Manutenzioni elettromeccaniche impianti elettrici, civili e industriali. Consulenze energetiche con sistemi di monitoraggio a distanza. Sicurezza sul lavoro secondo quanto previsto dal D.Legs. 81/08, s.m.i. e Cooperazione e Coordinamento previsto dall’art. 26." />                    
          <Form name={formLayout.name} title="Compila il form e ti risponderemo appena possibile"layout={formLayout.layout}></Form>
          <Footer />
          <FooterAlt />
          </React.Fragment>)
}

export default Assistenza;